import WaiveInterestDialog from './WaiveInterestDialog.vue';

export default WaiveInterestDialog;
